import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class YektanetService {

  constructor(private http: HttpClient) { }

  getNajvaSetting() {
    return this.http.get<any>(environment.app.apiUrl + 'yektanet/get-najva-setting').toPromise();
  }

  fetchNajvaSegments() {
    return this.http.post<any>(environment.app.apiUrl + 'yektanet/fetch-najva-segments', null).toPromise();
  }
}

export class ProductInfo {
  title: string;
  sku: string;
  category?: string[] = [];
  price?= 0;
  brand?= 'کارپیشه';
  discount?= 0;
  image: string;
  isAvailable = false;
}
